// kontroll-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'ktr.title': 'Revisión',
  'ktr.subtitle': 'Trabajo a la espera de que alguien distinto de quien lo realizó lo avale.',
  'ktr.view.matrix': 'Matriz',
  'ktr.view.list': 'Lista de revisiones',
  'ktr.refresh': 'Actualizar',
  'ktr.notController': 'El despacho no te ha designado como revisor. Puedes ver las revisiones, pero no aprobarlas.',
  'ktr.empty.title': 'Nada que revisar',
  'ktr.empty.text': 'Una revisión se crea cuando alguien envía un período conciliado a revisión desde la carpeta de conciliación.',
  'ktr.controlNotFound': 'No se encontró la revisión. ¿Tienes acceso a esta contabilidad?',
  'ktr.kpi.new': 'Nuevas para revisar',
  'ktr.kpi.active': 'En curso',
  'ktr.kpi.awaitingPerformer': 'A la espera del ejecutor',
  'ktr.kpi.due7': 'Vencen en los próximos 7 días',
  'ktr.kpi.overdue': 'Plazo vencido',
  'ktr.kpi.approved': 'Aprobadas',
  'ktr.search.placeholder': 'Buscar por cliente o n.º de organización',
  'ktr.search.label': 'Buscar cliente',
  'ktr.filter.allScopes': 'Todos los alcances',
  'ktr.filter.allPerformers': 'Todos los ejecutores',
  'ktr.filter.allStatuses': 'Todos los estados',
  'ktr.filter.clientGroup': 'Grupo de clientes',
  'ktr.filter.allClientGroups': 'Todos los grupos de clientes',
  'ktr.filter.allDeadlines': 'Todos los plazos',
  'ktr.filter.next7Days': 'Próximos 7 días',
  'ktr.filter.onlyMine': 'Solo mis revisiones',
  'ktr.filter.onlyDeviations': 'Solo con desviaciones',
  'ktr.filter.reset': 'Restablecer',
  'ktr.filter.showing': 'Mostrando:',
  'ktr.filter.remove': 'Quitar filtro',
  'ktr.history.empty': 'Aún no hay historial.',
  'ktr.history.system': 'El sistema',
  'ktr.history.submitted': 'envió el período a revisión',
  'ktr.history.resubmitted': 'lo reenvió (versión {version})',
  'ktr.history.pointUpdated': 'evaluó un punto de revisión',
  'ktr.history.approved': 'aprobó la revisión (versión {version})',
  'ktr.history.returned': 'la devolvió al ejecutor – {note}',
  'ktr.history.reopened': 'reabrió la revisión – {reason}',
  'ktr.history.assigned': 'asignó la revisión a un revisor',
  'ktr.history.unassigned': 'devolvió la revisión a la cola',
  'ktr.history.documentationRequested': 'solicitó documentación – {note}',
  'ktr.history.documentationResolved': 'marcó la documentación como recibida',
  'ktr.history.basisChanged': 'la contabilidad cambió tras la aprobación',
  'ktr.status.new': 'Nueva',
  'ktr.status.underControl': 'En revisión',
  'ktr.status.awaitingDocs': 'A la espera de documentación',
  'ktr.status.returned': 'Devuelta al ejecutor',
  'ktr.status.resubmitted': 'Reenviada',
  'ktr.status.approved': 'Revisada y aprobada',
  'ktr.status.changedAfter': 'Modificada tras la aprobación',
  'ktr.action.start': 'Iniciar revisión',
  'ktr.action.continue': 'Continuar revisión',
  'ktr.action.seeStatus': 'Ver estado',
  'ktr.action.reviewChanges': 'Revisar cambios',
  'ktr.action.seeApproved': 'Ver revisión aprobada',
  'ktr.wholePeriod': 'Todo el período',
  'ktr.point.notAssessed': 'Sin evaluar',
  'ktr.point.ok': 'OK',
  'ktr.point.remark': 'Observación',
  'ktr.point.mustFix': 'Debe corregirse',
  'ktr.point.fromReconciliation': 'De la conciliación',
  'ktr.point.sourceLine': 'Cuenta {account} · sin explicar {amount} kr',
  'ktr.point.openSource': 'Abrir en la base',
  'ktr.point.observedPlaceholder': '¿Qué se ha observado?',
  'ktr.fix.responsibleLabel': 'Responsable de la corrección',
  'ktr.fix.responsiblePlaceholder': 'Responsable …',
  'ktr.fix.deadlineLabel': 'Plazo de la corrección',
  'ktr.fix.linkedPlaceholder': 'Vinculado a (cuenta, justificante o sección)',
  'ktr.fix.linkedLabel': 'Vinculado a',
  'ktr.deadline.none': 'Sin plazo',
  'ktr.deadline.overdueOne': '{date} · vencido hace {days} día',
  'ktr.deadline.overdueMany': '{date} · vencido hace {days} días',
  'ktr.deadline.today': '{date} · hoy',
  'ktr.deadline.inOne': '{date} · en {days} día',
  'ktr.deadline.inMany': '{date} · en {days} días',
  'ktr.priority.high': 'Alta',
  'ktr.priority.medium': 'Media',
  'ktr.priority.low': 'Baja',
  'ktr.reason.approverIsPerformer': 'No puedes aprobar un trabajo que realizaste tú. La revisión requiere a otra persona.',
  'ktr.reason.approverNotController': 'El despacho no te ha designado como revisor.',
  'ktr.reason.approverUnknown': 'No se te encontró como miembro del despacho.',
  'ktr.reason.alreadyApproved': 'La revisión ya está aprobada.',
  'ktr.reason.returnedToPerformer': 'La revisión se ha devuelto al ejecutor.',
  'ktr.reason.noControlPoints': 'La revisión no tiene puntos.',
  'ktr.reason.pointMustBeFixed': 'Al menos un punto figura como «Debe corregirse».',
  'ktr.reason.pointNotAssessed': 'Al menos un punto no se ha evaluado.',
  'ktr.reason.noteMissingText': 'A una observación le falta el texto.',
  'ktr.reason.nothingToReturn': 'Ningún punto señala nada. Marca primero lo que debe corregirse.',
  'ktr.reason.documentationRequestOpen': 'La solicitud de documentos que enviaste aún no ha sido respondida.',
  'ktr.reason.conclusionRequired': 'La revisión tiene desviaciones u observaciones. Entonces hay que redactar la conclusión.',
  'ktr.reason.basisChangedSinceSubmit': 'Las cifras han cambiado desde que se envió el trabajo. Solicita un nuevo envío antes de aprobar.',
  'ktr.reason.periodAreaBlocked': 'Un área del período no ha terminado de revisarse.',
  'ktr.reason.assigneeUnknown': 'No se encontró a la persona como miembro del despacho.',
  'ktr.reason.assigneeIsPerformer': 'Quien realizó el trabajo no puede asignarse para revisarlo.',
  'ktr.reason.assigneeNotController': 'El despacho no ha designado a esta persona como revisor.',
  'ktr.diff.bookedBalance': 'Saldo contabilizado',
  'ktr.diff.unexplainedDifference': 'Diferencia sin explicar',
  'ktr.diff.sameNumbers': 'Las cifras son las mismas que la vez anterior. El cambio está en la documentación o en las explicaciones.',
  'ktr.diff.accountsChangedOne': '{count} cuenta cambió',
  'ktr.diff.accountsChangedMany': '{count} cuentas cambiaron',
  'ktr.diff.versionRange': 'versión {from} → {to}',
  'ktr.diff.changed': 'Modificadas',
  'ktr.diff.added': 'Añadidas',
  'ktr.diff.removed': 'Eliminadas',
  'ktr.diff.performerReply': 'Respuesta del ejecutor',
  'ktr.diff.changedAfterApproval': 'Modificada tras la aprobación',
  'ktr.diff.resubmittedWhatChanged': 'Reenviada — qué ha cambiado',
  'ktr.diff.reopenAndRecheck': 'Reabrir y revisar de nuevo',
  'ktr.col.priority': 'Prioridad',
  'ktr.col.client': 'Cliente',
  'ktr.col.period': 'Período',
  'ktr.col.scope': 'Alcance',
  'ktr.col.performedBy': 'Ejecutado por',
  'ktr.col.sentTitle': 'Enviada a revisión',
  'ktr.col.sent': 'Enviada',
  'ktr.col.deviationsTitle': 'Desviaciones críticas',
  'ktr.col.deviations': 'Desviaciones',
  'ktr.col.progressTitle': 'Avance de la revisión',
  'ktr.col.progress': 'Avance',
  'ktr.col.assignedTitle': 'Revisor asignado',
  'ktr.col.assigned': 'Asignado',
  'ktr.col.deadlineTitle': 'Plazo de revisión',
  'ktr.col.deadline': 'Plazo',
  'ktr.col.status': 'Estado',
  'ktr.col.periodApproval': 'Aprobación del período',
  'ktr.notAssigned': 'Sin asignar',
  'ktr.assignedControllerFor': 'Revisor asignado para {name}',
  'ktr.overdueShort': 'vencido',
  'ktr.progressCount': '{done} de {total}',
  'ktr.noControlsMatch': 'Ninguna revisión coincide con los filtros.',
  'ktr.noClientsMatch': 'Ningún cliente coincide con los filtros.',
  'ktr.orgNumber': 'Org. {org}',
  'ktr.noOrgNumber': 'Sin n.º de organización',
  'ktr.open': 'Abrir',
  'ktr.openControl': 'Abrir revisión',
  'ktr.cell.notSent': 'No enviada a revisión',
  'ktr.cell.performedBy': 'Ejecutado por {email}',
  'ktr.cell.assigned': 'Asignado a {name}',
  'ktr.cell.deadline': 'Plazo {deadline}',
  'ktr.cell.critical': '{count} desviaciones críticas',
  'ktr.cell.version': 'Versión {version}',
  'ktr.period.notSent': 'No enviado',
  'ktr.period.partlySent': 'Enviado parcialmente',
  'ktr.period.blocked': 'Bloqueado',
  'ktr.period.ready': 'Listo para la aprobación del período',
});
